import { c as _c } from "react/compiler-runtime";
import { GetStaticPropsContext, InferGetStaticPropsType } from "next";
import { fetchRouterContext } from "../../context/RouterContext";
import { ArticlePage, getArticlePaths } from "../ArticlePage";
import { GenericPage, getGenericPagePaths } from "../GenericPage";
import { ArticlesPage } from "../ArticlesPage";
import { VippsAgreementPage } from "../VippsAgreementPage";
import { DonationsPage, getDonationsPageSubpaths } from "../dashboard/DonationsPage";
import { AgreementsPage } from "../dashboard/AgreementsPage";
import { ProfilePage } from "../dashboard/ProfilePage";
import { TaxPage, getTaxPageSubPaths } from "../dashboard/TaxPage";
import { VippsAnonymousPage } from "../dashboard/VippsAnonymousPage";
import { ResultsPage } from "../ResultsPage";
import { useLiveQuery } from "@sanity/preview-kit";
import { ConsentState } from "../../proxy.page";
import { FundraiserPage, getFundraiserPagePaths } from "../FundraiserPage";
import { renderLatexInData } from "../../components/main/blocks/Paragraph/renderLatex";
enum PageType {
  GenericPage = "generic",
  ArticlesPage = "articles",
  ResultsPage = "results",
  ArticlePage = "article",
  FundraiserPage = "fundraiser",
  VippsAgreementPage = "vipps-agreement",
  VippsAnonymousPage = "vipps-anonymous",
  AgreementsPage = "agreements",
  DonationsPage = "donations",
  ProfilePage = "profile",
  TaxPage = "tax",
}
const Page: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = props => {
  const $ = _c(32);
  if (props.appStaticProps?.layoutProps?.draftMode || true) {
    switch (props.pageType as PageType) {
      case PageType.GenericPage:
        {
          const t0 = props as any;
          let t1;
          if ($[0] !== t0) {
            t1 = <PreviewGenericPage {...t0} />;
            $[0] = t0;
            $[1] = t1;
          } else {
            t1 = $[1];
          }
          return t1;
        }
      case PageType.ArticlesPage:
        {
          const t0 = props as any;
          let t1;
          if ($[2] !== t0) {
            t1 = <PreviewArticlesPage {...t0} />;
            $[2] = t0;
            $[3] = t1;
          } else {
            t1 = $[3];
          }
          return t1;
        }
      case PageType.ArticlePage:
        {
          const t0 = props as any;
          let t1;
          if ($[4] !== t0) {
            t1 = <PreviewArticlePage {...t0} />;
            $[4] = t0;
            $[5] = t1;
          } else {
            t1 = $[5];
          }
          return t1;
        }
      case PageType.ResultsPage:
        {
          const t0 = props as any;
          let t1;
          if ($[6] !== t0) {
            t1 = <PreviewResultsPage {...t0} />;
            $[6] = t0;
            $[7] = t1;
          } else {
            t1 = $[7];
          }
          return t1;
        }
      case PageType.FundraiserPage:
        {
          const t0 = props as any;
          let t1;
          if ($[8] !== t0) {
            t1 = <PreviewFundraiserPage {...t0} />;
            $[8] = t0;
            $[9] = t1;
          } else {
            t1 = $[9];
          }
          return t1;
        }
    }
  }
  switch (props.pageType as PageType) {
    case PageType.GenericPage:
      {
        const t0 = props as any;
        let t1;
        if ($[10] !== t0) {
          t1 = <GenericPage {...t0} />;
          $[10] = t0;
          $[11] = t1;
        } else {
          t1 = $[11];
        }
        return t1;
      }
    case PageType.ArticlesPage:
      {
        const t0 = props as any;
        let t1;
        if ($[12] !== t0) {
          t1 = <ArticlesPage {...t0} />;
          $[12] = t0;
          $[13] = t1;
        } else {
          t1 = $[13];
        }
        return t1;
      }
    case PageType.ArticlePage:
      {
        const t0 = props as any;
        let t1;
        if ($[14] !== t0) {
          t1 = <ArticlePage {...t0} />;
          $[14] = t0;
          $[15] = t1;
        } else {
          t1 = $[15];
        }
        return t1;
      }
    case PageType.ResultsPage:
      {
        const t0 = props as any;
        let t1;
        if ($[16] !== t0) {
          t1 = <ResultsPage {...t0} />;
          $[16] = t0;
          $[17] = t1;
        } else {
          t1 = $[17];
        }
        return t1;
      }
    case PageType.FundraiserPage:
      {
        const t0 = props as any;
        let t1;
        if ($[18] !== t0) {
          t1 = <FundraiserPage {...t0} />;
          $[18] = t0;
          $[19] = t1;
        } else {
          t1 = $[19];
        }
        return t1;
      }
    case PageType.VippsAgreementPage:
      {
        const t0 = props as any;
        let t1;
        if ($[20] !== t0) {
          t1 = <VippsAgreementPage {...t0} />;
          $[20] = t0;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        return t1;
      }
    case PageType.AgreementsPage:
      {
        const t0 = props as any;
        let t1;
        if ($[22] !== t0) {
          t1 = <AgreementsPage {...t0} />;
          $[22] = t0;
          $[23] = t1;
        } else {
          t1 = $[23];
        }
        return t1;
      }
    case PageType.VippsAnonymousPage:
      {
        const t0 = props as any;
        let t1;
        if ($[24] !== t0) {
          t1 = <VippsAnonymousPage {...t0} />;
          $[24] = t0;
          $[25] = t1;
        } else {
          t1 = $[25];
        }
        return t1;
      }
    case PageType.DonationsPage:
      {
        const t0 = props as any;
        let t1;
        if ($[26] !== t0) {
          t1 = <DonationsPage {...t0} />;
          $[26] = t0;
          $[27] = t1;
        } else {
          t1 = $[27];
        }
        return t1;
      }
    case PageType.ProfilePage:
      {
        const t0 = props as any;
        let t1;
        if ($[28] !== t0) {
          t1 = <ProfilePage {...t0} />;
          $[28] = t0;
          $[29] = t1;
        } else {
          t1 = $[29];
        }
        return t1;
      }
    case PageType.TaxPage:
      {
        const t0 = props as any;
        let t1;
        if ($[30] !== t0) {
          t1 = <TaxPage {...t0} />;
          $[30] = t0;
          $[31] = t1;
        } else {
          t1 = $[31];
        }
        return t1;
      }
  }
};
const PreviewGenericPage: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = props => {
  const [result] = useLiveQuery(props.data.result, props.data.query, {
    ...props.data.queryParams
  });
  if (result) {
    props.data.result = result;
  }
  return <GenericPage {...props as any} />;
};
const PreviewArticlesPage: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = props => {
  const [result] = useLiveQuery(props.data.result, props.data.query, {
    ...props.data.queryParams
  });
  if (result) {
    props.data.result = result;
  }
  return <ArticlesPage {...props as any} />;
};
const PreviewArticlePage: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = props => {
  const [result] = useLiveQuery(props.data.result, props.data.query, {
    ...props.data.queryParams
  });
  if (result) {
    props.data.result = result;
  }
  return <ArticlePage {...props as any} />;
};
const PreviewResultsPage: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = props => {
  const [result] = useLiveQuery(props.data.result, props.data.query, {
    ...props.data.queryParams
  });
  if (result) {
    props.data.result = result;
  }
  return <ResultsPage {...props as any} />;
};
const PreviewFundraiserPage: React.FC<InferGetStaticPropsType<typeof getStaticProps>> = props => {
  const [result] = useLiveQuery(props.data.result, props.data.query, {
    ...props.data.queryParams
  });
  if (result) {
    props.data.result = result;
  }
  return <FundraiserPage {...props as any} />;
};
function compareArrays<T>(a: T[], b: T[]) {
  return a.length === b.length && a.every((v, i) => v === b[i]);
}
const inferPageTypeFromPath = async (path: string[]) => {
  const {
    articlesPagePath,
    fundraisersPath,
    resultsPagePath,
    vippsAgreementPagePath,
    dashboardPath,
    agreementsPagePath,
    taxPagePath,
    profilePagePath,
    vippsAnonymousPagePath
  } = await fetchRouterContext();
  const isVippsAgreementPage = vippsAgreementPagePath && compareArrays(path.slice(0, vippsAgreementPagePath.length), vippsAgreementPagePath);
  if (isVippsAgreementPage) return PageType.VippsAgreementPage;
  const isArticle = compareArrays(path.slice(0, articlesPagePath.length), articlesPagePath) && path.length > articlesPagePath.length;
  if (isArticle) return PageType.ArticlePage;
  const isFundraiser = compareArrays(path.slice(0, fundraisersPath.length), fundraisersPath) && path.length > fundraisersPath.length;
  if (isFundraiser) return PageType.FundraiserPage;
  const isArticlesPage = compareArrays(path.slice(0, articlesPagePath.length), articlesPagePath);
  if (isArticlesPage) return PageType.ArticlesPage;
  const isResultsPage = compareArrays(path.slice(0, resultsPagePath.length), resultsPagePath);
  if (isResultsPage) return PageType.ResultsPage;
  const isDashboard = dashboardPath ? compareArrays(path.slice(0, dashboardPath.length), dashboardPath) : false;
  if (isDashboard) {
    const isAgreementsPage = agreementsPagePath ? compareArrays(path.slice(0, agreementsPagePath.length), agreementsPagePath) : false;
    if (isAgreementsPage) return PageType.AgreementsPage;
    const isVippsAnonymousPage = vippsAnonymousPagePath ? compareArrays(path.slice(0, vippsAnonymousPagePath.length), vippsAnonymousPagePath) : false;
    if (isVippsAnonymousPage) return PageType.VippsAnonymousPage;
    const isTaxPage = taxPagePath ? compareArrays(path.slice(0, taxPagePath.length), taxPagePath) : false;
    if (isTaxPage) return PageType.TaxPage;
    const isProfilePage = profilePagePath ? compareArrays(path.slice(0, profilePagePath.length), profilePagePath) : false;
    if (isProfilePage) return PageType.ProfilePage;
    return PageType.DonationsPage;
  }
  return PageType.GenericPage;
};
export const getStaticProps = async (ctx: GetStaticPropsContext<{
  slug: string[];
  state: ConsentState;
}>) => {
  const result = await getPageStaticProps(ctx);
  // Render LaTeX on the server, so neither katex nor stale Studio-rendered HTML reaches the client
  return (result && "props" in result ? {
    ...result,
    props: renderLatexInData(result.props)
  } : result) as typeof result;
};
const getPageStaticProps = async (ctx: GetStaticPropsContext<{
  slug: string[];
  state: ConsentState;
}>) => {
  const path = ctx.params?.slug ?? [];
  const draftMode = ctx.draftMode ?? false;
  const consentState = ctx.params?.state ?? "undecided";
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL ?? "";
  const isDanishSite = siteUrl.includes("giveffektivt.dk");
  const revalidate = isDanishSite || draftMode ? 1 : 3600;
  const pageType = await inferPageTypeFromPath(path);
  switch (pageType) {
    case PageType.GenericPage:
      {
        const props = await GenericPage.getStaticProps({
          draftMode,
          consentState,
          path
        });
        if (!props.data.result.page && !draftMode) {
          return {
            notFound: true
          };
        }
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.ArticlesPage:
      {
        const props = await ArticlesPage.getStaticProps({
          draftMode,
          consentState
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.ArticlePage:
      {
        const slug = path.slice(1).join("/");
        const props = await ArticlePage.getStaticProps({
          draftMode,
          consentState,
          slug
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.FundraiserPage:
      {
        const slug = path.slice(1).join("/");
        const props = await FundraiserPage.getStaticProps({
          draftMode,
          consentState,
          slug
        });
        if (!props.data.result.page && !draftMode) {
          return {
            notFound: true
          };
        }
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.ResultsPage:
      {
        const props = await ResultsPage.getStaticProps({
          draftMode,
          consentState
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.VippsAgreementPage:
      {
        const props = await VippsAgreementPage.getStaticProps({
          draftMode,
          consentState
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.VippsAnonymousPage:
      {
        const props = await VippsAnonymousPage.getStaticProps({
          draftMode,
          consentState
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.DonationsPage:
      {
        const props = await DonationsPage.getStaticProps({
          draftMode,
          consentState,
          path
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.AgreementsPage:
      {
        const props = await AgreementsPage.getStaticProps({
          draftMode,
          consentState,
          slug: path
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.ProfilePage:
      {
        const props = await ProfilePage.getStaticProps({
          draftMode,
          consentState
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
    case PageType.TaxPage:
      {
        const props = await TaxPage.getStaticProps({
          draftMode,
          path,
          consentState
        });
        return {
          props: {
            ...props,
            pageType,
            consentState
          },
          revalidate
        } as const;
      }
  }
};
export async function getStaticPaths() {
  const routerContext = await fetchRouterContext();
  const basePaths = await Promise.all([getGenericPagePaths(), getArticlePaths(routerContext.articlesPagePath), getFundraiserPagePaths(routerContext.fundraisersPath), getDonationsPageSubpaths(), getTaxPageSubPaths()]).then(([genericPagePaths, articlePaths, donationsPageSubpaths, taxPageSubPaths]) => [...genericPagePaths, ...articlePaths, ...donationsPageSubpaths, ...taxPageSubPaths, ...(Object.values(routerContext).filter(path => path !== null) as string[][])]);
  const consentStates: ConsentState[] = ["accepted", "rejected", "undecided"];
  return {
    paths: basePaths.flatMap(path => consentStates.map(state => ({
      params: {
        // The frontpage slug "/" splits into ["", ""]; empty segments produce a
        // trailing-slash path ("/accepted/") that breaks Vercel's Next.js adapter
        slug: path.filter(segment => segment !== ""),
        state
      }
    }))),
    fallback: "blocking"
  };
}
export default Page;